import './resizeObserverPatch';
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.jsx'
import reportWebVitals from './reportWebVitals';
import 'antd/dist/reset.css';
import './styles/studio-theme.css';
import './styles/operational-theme.css'

// react-pdf-highlighter-extended styles
import 'react-pdf-highlighter-extended/dist/esm/style/pdf_viewer.css';
import 'react-pdf-highlighter-extended/dist/esm/style/PdfHighlighter.css';
import 'react-pdf-highlighter-extended/dist/esm/style/MouseSelection.css';
import 'react-pdf-highlighter-extended/dist/esm/style/TextHighlight.css';
import 'react-pdf-highlighter-extended/dist/esm/style/AreaHighlight.css';

//import { pdfjs } from 'react-pdf-highlighter-extended';
import * as pdfjs from 'pdfjs-dist'; 

pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';



const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals()